module.exports = __webpack_public_path__ + "static/img/logo1.f6570a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/indexImg/logo1.png
// module id = GQl+
// module chunks = 8